import { getStoredSession, setStoredSession, type AuthSession } from './session';
import { api } from './api';

const RETURN_SESSION_KEY = 'platform_admin_return_session';
const IMPERSONATION_KEY = 'platform_impersonation';

export interface ImpersonationState {
  target_email: string;
  admin_email: string;
  started_at: string;
}

export function getImpersonationState(): ImpersonationState | null {
  try {
    const raw = sessionStorage.getItem(IMPERSONATION_KEY);
    return raw ? JSON.parse(raw) as ImpersonationState : null;
  } catch {
    return null;
  }
}

export async function startImpersonation(_userId: string): Promise<void> {
  const session = getStoredSession();
  if (!session) throw new Error('Not signed in');

  // TODO: reimplement impersonation with server-minted JWT after Supabase removal.
  throw new Error('Admin impersonation is temporarily unavailable with Google-only auth.');
}

export async function exitImpersonation(): Promise<void> {
  const raw = sessionStorage.getItem(RETURN_SESSION_KEY);
  sessionStorage.removeItem(IMPERSONATION_KEY);
  sessionStorage.removeItem(RETURN_SESSION_KEY);

  if (!raw) {
    setStoredSession(null);
    return;
  }

  const saved = JSON.parse(raw) as AuthSession;
  setStoredSession(saved);
}
